export default __webpack_public_path__ + "static/media/extra_in_l1.517166da.svg";